import { theme } from 'antd';
import type { ThemeConfig } from 'antd';

/**
 * 应用的暗色主题配置
 */
export const darkTheme: ThemeConfig = {
  algorithm: theme.darkAlgorithm,
  components: {
    Layout: {
      headerBg: "#1f1f1f",
    },
    Input: {
      colorBgContainer: "#303030",
      colorBorder: "#555555",
    },
    Select: {
      colorBgContainer: "#303030",
      colorBorder: "#555555",
      colorTextPlaceholder: "#8c8c8c",
    },
    Button: {
      colorPrimary: "#1668dc",
      colorPrimaryHover: "#388eff",
      colorPrimaryActive: "#0950b3",
      defaultBg: "#2b2b2b",
      defaultBorderColor: "#444444",
      defaultColor: "#e0e0e0",
      defaultHoverBg: "#383838",
      defaultHoverBorderColor: "#666666",
      defaultHoverColor: "#ffffff",
      defaultActiveBg: "#404040",
      defaultActiveBorderColor: "#777777",
      defaultActiveColor: "#ffffff",
    },
    Table: {
      borderColor: "#333333",
      headerBg: "#232323",
    },
  },
}; 